import { PauseCircle } from 'lucide-react';

/**
 * What a guest sees when the gallery behind their link has had sharing
 * switched off from the admin.
 *
 * The link is still good — the switch is meant to be temporary and does not
 * touch the tokens — so this says "paused", never "not found". Nothing here
 * reveals the gallery's name or photo count; the whole point of the switch is
 * that the contents stop being visible.
 */
export default function GalleryUnavailable() {
  return (
    <div className="min-h-screen bg-tiq-nearblack flex items-center justify-center text-white">
      <div className="text-center px-6 max-w-md">
        <PauseCircle className="w-12 h-12 mx-auto mb-5" style={{ color: 'rgba(255,255,255,0.35)' }} />
        <h1
          className="font-tiq-display uppercase mb-3"
          style={{ fontWeight: 900, fontSize: 32, letterSpacing: '-0.02em' }}
        >
          Gallery paused
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>
          This gallery has been temporarily switched off. Your link still works —
          it will open again once the gallery is back on.
        </p>
        <p className="mt-4" style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>
          Need it sooner? Contact the person who sent you the link, or{' '}
          <a
            href="mailto:hello@turbo360.com.au"
            className="underline"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            hello@turbo360.com.au
          </a>
          .
        </p>
      </div>
    </div>
  );
}
